var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0125 7.99377V55.8688H12.0437V7.99377H52.0125ZM52.0125 3.99377H12.0437C9.83745 3.99377 8.0437 5.78752 8.0437 7.99377V55.8688C8.0437 58.075 9.83745 59.8688 12.0437 59.8688H52.0125C54.2187 59.8688 56.0125 58.075 56.0125 55.8688V7.99377C56.0125 5.78127 54.2187 3.99377 52.0125 3.99377Z",
    fill: "#EAB187"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0124 59.8938H32.5874V48.8938C32.5874 46.6875 34.3812 44.8938 36.5874 44.8938H56.0124C58.2187 44.8938 60.0124 46.6875 60.0124 48.8938V55.8938C60.0124 58.1063 58.2187 59.8938 56.0124 59.8938Z",
    fill: "#D39262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34H23.102L24.51 30.436H31.264L32.716 34H35.884L29.174 18.424H26.776L20 34ZM25.456 28.06L27.898 21.724L30.296 28.06H25.456ZM37.527 34H40.167V23.44H37.527V34ZM37.153 19.854C37.153 20.69 37.857 21.438 38.825 21.438C39.793 21.438 40.541 20.756 40.541 19.854C40.541 18.952 39.793 18.27 38.825 18.27C37.857 18.27 37.153 19.018 37.153 19.854Z",
    fill: "#EAB187"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57H41.692L42.46 55.056H46.144L46.936 57H48.664L45.004 48.504H43.696L40 57ZM42.976 53.76L44.308 50.304L45.616 53.76H42.976ZM49.6322 57H51.1442V48.504H49.6322V57Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.ef09b8b6a3953393f2eed0c6c95d73a1.svg";
export { ForwardRef as ReactComponent };